export default __webpack_public_path__ + "static/logo_firebase-f2fa7f145a81e3f3ab8d372a761a7540.png";